import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";

const StaticPage = () => {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [nf, setNf] = useState(false);
  const [emails, setEmails] = useState([]);
  useEffect(() => {
    setP(null); setNf(false); window.scrollTo(0, 0);
    api.get(`/pages/${slug}`).then((r) => setP(r.data)).catch(() => setNf(true));
    if (slug === "contact") api.get("/settings").then((r) => setEmails(r.data.contact_emails || [])).catch(() => {});
  }, [slug]);
  if (nf) return <div className="min-h-[60vh] flex items-center justify-center font-serif text-3xl">She's not here.</div>;
  if (!p) return <div className="min-h-[60vh]" />;
  return (
    <div className="max-w-2xl mx-auto px-6 pt-20 md:pt-28 pb-24">
      <p className="overline text-gold mb-4">{p.title}</p>
      <h1 className="font-serif text-5xl md:text-7xl leading-none mb-10">{p.heading}</h1>
      <div className="text-espresso/75 leading-loose whitespace-pre-line text-lg">{p.body}</div>
      {slug === "returns-exchanges" && (
        <Link to="/returns/start" data-testid="start-return-btn"
          className="inline-block mt-8 bg-espresso text-cream px-8 py-3.5 text-[0.72rem] tracking-[0.2em] uppercase hover:bg-cocoa transition-colors">Start a return</Link>
      )}
      {slug === "contact" && emails.length > 0 && (
        <div className="mt-8 space-y-2" data-testid="contact-emails">
          {emails.map((e) => (
            <a key={e} href={`mailto:${e}`} data-testid={`contact-email-${e}`}
              className="block text-espresso text-lg underline underline-offset-4 decoration-gold hover:text-gold transition-colors">{e}</a>
          ))}
        </div>
      )}
    </div>
  );
};

export default StaticPage;
